import { createContext } from "react";
import useLotChangesByLotId from "../hooks/data/useLotChangesByLotId";

export interface ILotChangesContext extends ReturnType<typeof useLotChangesByLotId> {

};

const LotChangesContext = createContext<ILotChangesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default LotChangesContext